<div class="training-request-modal">
  <h2 mat-dialog-title>Request Training</h2>
  
  <mat-dialog-content>
    <p class="instruction-text">Customize your training request message to your manager (optional):</p>
    
    <mat-form-field appearance="outline" class="full-width">
      <textarea 
        matInput 
        [(ngModel)]="message"
        rows="4"
        class="message-textarea">
      </textarea>
    </mat-form-field>
    
    <p class="hint-text">Click Send to use the default message, or customize it above.</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="send()">Send</button>
  </mat-dialog-actions>
</div>
